import React from 'react';
import { Outlet } from 'react-router';
import styled from 'styled-components';

const StyledWithNavLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
`;

export function WithNavLayout() {
  return (
    <StyledWithNavLayout>
      <Outlet />
    </StyledWithNavLayout>
  );
}
